import { Locale } from 'react-day-picker'

const defaultLocale = 'en-GB'
export const getLocaleDateFormat = (locale?: Locale) => {
  const formatter = new Intl.DateTimeFormat(locale?.code || defaultLocale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })

  const parts = formatter.formatToParts(new Date())
  return parts
    .map(part => {
      switch (part.type) {
        case 'month':
          return 'MM'
        case 'day':
          return 'dd'
        case 'year':
          return 'yyyy'
        default:
          return part.value
      }
    })
    .join('')
}
